/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementStep {
    SURVEY = 'survey',
    JOB_MAPPINGS = 'jobMappings',
    DATA_CUT_MAPPINGS = 'dataCutMappings',
    COMPOSITE_DATA_CUTS = 'compositeDataCuts',
}
